import { HOUR_MS } from '@calm/web-common/dist/time';
import createAccountApi from '@rhg/libs/api/create-account-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export const gendersQueryOptions = {
    queryKey: () => [queryKeys.genders],
    queryFn: async (
        getAccessTokenSilently: () => Promise<string>,
        isAuthenticated: boolean
    ) => {
        if (!isAuthenticated) {
            return [];
        }
        const accountApi = createAccountApi(getAccessTokenSilently);

        const response = await accountApi.getGendersV1({});

        return response.data.genders ?? [];
    },
    queryOptions: (isAuthenticated: boolean) => ({
        enabled: isAuthenticated,
        staleTime: 8 * HOUR_MS,
    }),
};
export function useGenders() {
    const { isAuthenticated, getAccessTokenSilently } = useAuth();
    const { queryKey, queryFn, queryOptions } = gendersQueryOptions;

    const { data, ...otherProps } = useQuery({
        queryKey: queryKey(),
        queryFn: async () => queryFn(getAccessTokenSilently, isAuthenticated),
        ...queryOptions(isAuthenticated),
    });
    return {
        genders: data ?? [],
        ...otherProps,
    };
}
